export default __webpack_public_path__ + "static/media/loading-spinner.947f5303.png";